import { Box } from '@mui/material';
import { createContext, useContext, useState, type ReactNode } from 'react';
import { Panel } from '@/shared/ui';

export const DetailsSidePanelContext = createContext<HTMLDivElement | null>(
  null,
);

export function useDetailsSidePanelContext() {
  return useContext(DetailsSidePanelContext);
}

interface Props {
  open: boolean;
  children: ReactNode;
  width?: number;
}

export function DetailsSidePanel({ open, children, width = 340 }: Props) {
  const [contentEl, setContentEl] = useState<HTMLDivElement | null>(null);

  return (
    <Panel
      sx={{
        width: open ? width : 0,
        visibility: open ? 'visible' : 'hidden',
        ml: open ? 1 : 0,
        flexShrink: 0,
        transition: 'width 0.2s ease-in-out, margin 0.2s ease-in-out',
        position: 'relative',
        overflow: 'visible',
      }}
    >
      <Box
        ref={setContentEl}
        sx={{
          position: 'absolute',
          inset: 0,
          overflow: 'hidden',
          borderRadius: 4,
          opacity: open ? 1 : 0,
          transition: open ? 'opacity 0s ease-in-out 0.2s' : 'none',
        }}
      />
      <DetailsSidePanelContext.Provider value={contentEl}>
        {children}
      </DetailsSidePanelContext.Provider>
    </Panel>
  );
}
